export default "__VITE_ASSET__Ckg4W0cu__"